
import React from "react"
import { Link } from "gatsby"


export default function Footer(props) {


  return (
    <footer className="container">
      <div className="row">
        <div className="col-12 text-center">
          &copy; lemmerliese
        </div>
      </div>
    </footer>
  )
}

